export default __webpack_public_path__ + "e06cffdb3f035845f0309179ea7fec50.svg";